import { BasePaginatedUseCase } from "../../../../../common/domain/useCases/base_paginated_use_case";
import { IControlePatrimonioRepository } from "../../repositories/ControledePatrimonio";
import { OcorrenciaInspecaoPatrimonioLista } from "../../models/ocorrencia_inspecao_patrimonio_lista";
import { IGetAllOcorrenciaInspecaoPatrimonioUseCase } from "../../../presentation/useCases/read/get_all_ocorrencia_inspecao_patrimonio_use_case";

/**
 * GetAllOcorrenciaInspecaoPatrimonioUseCase
 */

export class GetAllOcorrenciaInspecaoPatrimonioUseCase
  extends BasePaginatedUseCase<OcorrenciaInspecaoPatrimonioLista>
  implements IGetAllOcorrenciaInspecaoPatrimonioUseCase {
  constructor(private readonly repository: IControlePatrimonioRepository) {
    super();
  }

  async getAllOcorrenciaInspecaoPatrimonio(
    idInspecaoPatrimonio: number,
    page?: number,
    rowsPerPage?: number,
  ): Promise<void> {
    const result = await this.repository.getAllOcorrenciaInspecaoPatrimonio(
      idInspecaoPatrimonio,
      page,
      rowsPerPage,
    );
    this._items = result.items;
    this._totalItems = result.totalItems;
    this._currentPage = result.currentPage;
    this._pageSize = result.pageSize;
    this._totalPages = result.totalPages;
  }
}
